import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { OrderProfileKeys } from '../models/order-profile-keys.enum';

@Injectable()
export class OrderToItemsMapperService {
  constructor(private t: TranslateService) {}

  /**
   * Maps the contents of an array field called "items" to another array of generic objects
   * @param order an unknown data-type (apparently not OrderDetail or OrderItem)
   */
  map(order) {
    return order.items.map(item => {
      return {
        titleItems: [
          {
            title: 'views.details.product_id',
            description: this.getProductCode(item.product).replace(/^0+/, ''),
          },
          {
            title: 'views.details.product_name',
            description: item.product.productDesc,
          },
        ],
        detailsRows: [
          [
            {
              title: 'views.review.quantity',
              description: item.quantity,
            },
            {
              title: 'views.review.unit',
              description: item.uom.unitCode,
            },
            {
              title: 'views.review.request_date',
              description: moment(item.requestedDateTime).format(this.t.instant('global.formatDate')),
            },
            {
              title: 'views.review.request_time',
              description: moment(item.requestedDateTime).format(this.t.instant('global.formatTime')),
            },
          ],
          this.getItemCatalogs(item.orderItemProfile),
          [
            {
              title: 'views.review.contract',
              description: item.agreementItem ? item.agreementItem.agreement.agreementCode : '',
              direction: 'ltr',
            },
          ],
        ],
      };
    });
  }

  getProductCode(product) {
    // Normal products
    if (product.commercialCode) {
      return product.commercialCode;
    }

    // Product from PCM (Hybris)
    if (product.productCode) {
      return product.productCode;
    }

    return '';
  }

  getItemCatalogs(orderItemProfile) {
    const allowed = Object.keys(OrderProfileKeys).map(key => OrderProfileKeys[key]);
    const descriptionKeyConversionTable = {
      slumpType: 'slump',
    };
    const booleanCatalogs = [];

    if (orderItemProfile.hasOwnProperty('kicker')) {
      booleanCatalogs.push({
        title: 'views.projectProfiles.kicker',
        description: orderItemProfile.kicker ? this.t.instant('views.common.yes') : this.t.instant('views.common.no'),
      });
    }

    if (!!orderItemProfile.additionalInfo) {
      booleanCatalogs.push({
        title: 'views.projectProfiles.additionalInfo',
        description: orderItemProfile.additionalInfo || '-',
      });
    }

    if (!!orderItemProfile.additionalServices) {
      booleanCatalogs.push({
        title: 'views.projectProfiles.additionalServices',
        description: orderItemProfile.additionalServices || '-',
      });
    }

    return Object.keys(orderItemProfile)
      .filter(key => allowed.includes(key) && orderItemProfile.hasOwnProperty(key))
      .map(key => {
        let descKey = key;
        if (descriptionKeyConversionTable.hasOwnProperty(key)) {
          descKey = descriptionKeyConversionTable[key];
        }

        if (!orderItemProfile[key].hasOwnProperty(descKey + 'Desc')) {
          return null;
        }

        return {
          title: `views.projectProfiles.${key}`,
          description: orderItemProfile[key][descKey + 'Desc'],
        };
      })
      .filter(item => item !== null)
      .concat(booleanCatalogs);
  }
}
